import React from 'react';

const FloatingActionBar = () => (
    <svg width='164' height='51' viewBox='0 0 164 51' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g filter='url(#filter0_dd_2386_36090)'>
            <g clipPath='url(#clip0_2386_36090)'>
                <rect
                    x='8.33301'
                    y='7.99976'
                    width='146.667'
                    height='29.3333'
                    rx='8'
                    fill='white'
                    shapeRendering='crispEdges'
                />
                <mask id='path-3-inside-1_2386_36090' fill='white'>
                    <path d='M8.33301 10.6665H37.6663V34.6665H8.33301V10.6665Z' />
                </mask>
                <path
                    d='M37.6663 10.6665H36.9997V34.6665H37.6663H38.333V10.6665H37.6663Z'
                    fill='#E1E1E0'
                    mask='url(#path-3-inside-1_2386_36090)'
                />
                <mask
                    id='mask0_2386_36090'
                    style={{ maskType: 'alpha' }}
                    maskUnits='userSpaceOnUse'
                    x='17'
                    y='17'
                    width='12'
                    height='11'
                >
                    <g clipPath='url(#clip1_2386_36090)'>
                        <path
                            d='M27.284 18.951L26.7151 18.3821C26.6651 18.3316 26.6056 18.2915 26.54 18.2641C26.4744 18.2368 26.404 18.2227 26.3329 18.2227C26.2618 18.2227 26.1914 18.2368 26.1258 18.2641C26.0602 18.2915 26.0007 18.3316 25.9507 18.3821L18.7151 25.6177C18.6646 25.6677 18.6245 25.7272 18.5971 25.7928C18.5698 25.8584 18.5557 25.9288 18.5557 25.9999C18.5557 26.071 18.5698 26.1414 18.5971 26.207C18.6245 26.2726 18.6646 26.3321 18.7151 26.3821L19.284 26.951C19.3337 27.0021 19.3932 27.0427 19.4588 27.0704C19.5245 27.0981 19.595 27.1124 19.6663 27.1124C19.7375 27.1124 19.8081 27.0981 19.8737 27.0704C19.9393 27.0427 19.9988 27.0021 20.0485 26.951L27.284 19.7155C27.3351 19.6658 27.3757 19.6063 27.4034 19.5407C27.4311 19.475 27.4454 19.4045 27.4454 19.3332C27.4454 19.262 27.4311 19.1914 27.4034 19.1258C27.3757 19.0601 27.3351 19.0007 27.284 18.951Z'
                            stroke='#0A0A0A'
                            strokeWidth='0.866667'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                        />
                        <path
                            d='M23.8887 20.4443L25.222 21.7777'
                            stroke='#0A0A0A'
                            strokeWidth='0.866667'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                        />
                        <path
                            d='M19.8887 19.9998V21.7775'
                            stroke='#0A0A0A'
                            strokeWidth='0.866667'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                        />
                        <path
                            d='M26.1113 23.5554V25.3332'
                            stroke='#0A0A0A'
                            strokeWidth='0.866667'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                        />
                        <path
                            d='M22.1113 18.2219V19.1108'
                            stroke='#0A0A0A'
                            strokeWidth='0.866667'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                        />
                        <path
                            d='M20.7778 20.8887H19'
                            stroke='#0A0A0A'
                            strokeWidth='0.866667'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                        />
                        <path
                            d='M26.9995 24.4443H25.2217'
                            stroke='#0A0A0A'
                            strokeWidth='0.866667'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                        />
                        <path
                            d='M22.5549 18.6665H21.666'
                            stroke='#0A0A0A'
                            strokeWidth='0.866667'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                        />
                    </g>
                </mask>
                <g mask='url(#mask0_2386_36090)'>
                    <rect x='17.666' y='17.3333' width='10.6667' height='10.6667' fill='white' />
                    <rect
                        x='17.666'
                        y='17.3333'
                        width='10.6667'
                        height='10.6667'
                        fill='url(#paint0_linear_2386_36090)'
                    />
                </g>
                <mask id='path-15-inside-2_2386_36090' fill='white'>
                    <path d='M37.666 10.6665H85.666V34.6665H37.666V10.6665Z' />
                </mask>
                <path
                    d='M85.666 10.6665H84.9993V34.6665H85.666H86.3327V10.6665H85.666Z'
                    fill='#E1E1E0'
                    mask='url(#path-15-inside-2_2386_36090)'
                />
                <path
                    d='M47.8887 22.6665L50.9998 19.5554L54.1109 22.6665'
                    stroke='#0A0A0A'
                    strokeWidth='0.833333'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M51 25.7776V19.5554'
                    stroke='#0A0A0A'
                    strokeWidth='0.833333'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M72.333 19.5554V25.7776'
                    stroke='#0A0A0A'
                    strokeWidth='0.833333'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M75.4439 22.6665L72.3328 25.7776L69.2217 22.6665'
                    stroke='#0A0A0A'
                    strokeWidth='0.833333'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <mask id='path-23-inside-3_2386_36090' fill='white'>
                    <path d='M85.666 10.6665H154.999V34.6665H85.666V10.6665Z' />
                </mask>
                <path
                    d='M154.999 10.6665H154.333V34.6665H154.999H155.666V10.6665H154.999Z'
                    fill='#E1E1E0'
                    mask='url(#path-23-inside-3_2386_36090)'
                />
                <g clipPath='url(#clip2_2386_36090)'>
                    <path
                        d='M98.7888 18.3532C98.8083 18.3139 98.8384 18.2808 98.8757 18.2576C98.913 18.2344 98.956 18.2222 98.9999 18.2222C99.0438 18.2222 99.0869 18.2344 99.1242 18.2576C99.1615 18.2808 99.1916 18.3139 99.211 18.3532L100.238 20.4328C100.305 20.5697 100.405 20.6881 100.529 20.7779C100.652 20.8677 100.796 20.9262 100.947 20.9483L103.243 21.2843C103.286 21.2906 103.327 21.309 103.361 21.3373C103.394 21.3656 103.419 21.4028 103.433 21.4446C103.446 21.4864 103.448 21.5312 103.438 21.5739C103.427 21.6166 103.405 21.6554 103.373 21.6861L101.713 23.303C101.603 23.4097 101.521 23.5414 101.474 23.6868C101.427 23.8322 101.416 23.987 101.441 24.1377L101.833 26.4221C101.841 26.4656 101.836 26.5104 101.82 26.5513C101.803 26.5923 101.775 26.6277 101.74 26.6537C101.704 26.6796 101.662 26.695 101.618 26.6981C101.574 26.7011 101.53 26.6918 101.491 26.671L99.4382 25.5919C99.3029 25.5209 99.1525 25.4838 98.9997 25.4838C98.847 25.4838 98.6965 25.5209 98.5613 25.5919L96.5093 26.671C96.4703 26.6916 96.4263 26.7009 96.3824 26.6978C96.3384 26.6947 96.2962 26.6793 96.2605 26.6533C96.2249 26.6274 96.1972 26.592 96.1807 26.5511C96.1641 26.5102 96.1594 26.4655 96.167 26.4221L96.5586 24.1381C96.5845 23.9873 96.5733 23.8325 96.5259 23.687C96.4786 23.5415 96.3966 23.4097 96.287 23.303L94.6266 21.6866C94.5949 21.6559 94.5724 21.617 94.5617 21.5742C94.551 21.5313 94.5526 21.4864 94.5662 21.4444C94.5798 21.4025 94.6049 21.3652 94.6387 21.3368C94.6725 21.3084 94.7136 21.2901 94.7573 21.2839L97.0528 20.9483C97.204 20.9263 97.3477 20.8679 97.4713 20.7781C97.5949 20.6883 97.6949 20.5698 97.7626 20.4328L98.7888 18.3532Z'
                        stroke='#0A0A0A'
                        strokeWidth='0.833333'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                </g>
                <g clipPath='url(#clip3_2386_36090)'>
                    <path
                        d='M121.666 22.6665V25.3332'
                        stroke='#0A0A0A'
                        strokeWidth='0.833333'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M120.333 23.9998H123'
                        stroke='#0A0A0A'
                        strokeWidth='0.833333'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M123.888 20.8887H119.444C118.953 20.8887 118.555 21.2866 118.555 21.7776V26.222C118.555 26.7129 118.953 27.1109 119.444 27.1109H123.888C124.379 27.1109 124.777 26.7129 124.777 26.222V21.7776C124.777 21.2866 124.379 20.8887 123.888 20.8887Z'
                        stroke='#0A0A0A'
                        strokeWidth='0.833333'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M116.778 24.4441C116.289 24.4441 115.889 24.0441 115.889 23.5553V19.1108C115.889 18.6219 116.289 18.2219 116.778 18.2219H121.222C121.711 18.2219 122.111 18.6219 122.111 19.1108'
                        stroke='#0A0A0A'
                        strokeWidth='0.833333'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                </g>
                <path
                    d='M140.777 22.2219V24.8886'
                    stroke='#DD4340'
                    strokeWidth='0.833333'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M142.555 22.2219V24.8886'
                    stroke='#DD4340'
                    strokeWidth='0.833333'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M144.777 19.9998V26.222C144.777 26.4577 144.683 26.6838 144.517 26.8505C144.35 27.0172 144.124 27.1109 143.888 27.1109H139.444C139.208 27.1109 138.982 27.0172 138.815 26.8505C138.648 26.6838 138.555 26.4577 138.555 26.222V19.9998'
                    stroke='#DD4340'
                    strokeWidth='0.833333'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M137.666 19.9998H145.666'
                    stroke='#DD4340'
                    strokeWidth='0.833333'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M139.889 19.9997V19.1108C139.889 18.8751 139.982 18.649 140.149 18.4823C140.316 18.3156 140.542 18.2219 140.778 18.2219H142.555C142.791 18.2219 143.017 18.3156 143.184 18.4823C143.351 18.649 143.444 18.8751 143.444 19.1108V19.9997'
                    stroke='#DD4340'
                    strokeWidth='0.833333'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </g>
            <rect
                x='8.16634'
                y='7.83309'
                width='147'
                height='29.6667'
                rx='8.16667'
                stroke='black'
                strokeOpacity='0.24'
                strokeWidth='0.333333'
                shapeRendering='crispEdges'
            />
        </g>
        <g filter='url(#filter1_dd_2386_36090)'>
            <rect
                x='81.666'
                y='5.33325'
                width='34.6667'
                height='34.6667'
                rx='17.3333'
                fill='white'
                shapeRendering='crispEdges'
            />
            <rect
                x='82.3327'
                y='5.99992'
                width='33.3333'
                height='33.3333'
                rx='16.6667'
                stroke='#6C42DE'
                strokeWidth='1.33333'
                shapeRendering='crispEdges'
            />
            <g clipPath='url(#clip4_2386_36090)'>
                <path
                    d='M98.6823 16.1968C98.7115 16.1378 98.7566 16.0881 98.8126 16.0534C98.8685 16.0187 98.9331 16.0002 98.9989 16.0002C99.0648 16.0002 99.1293 16.0187 99.1853 16.0534C99.2412 16.0881 99.2864 16.1378 99.3156 16.1968L100.856 19.3162C100.957 19.5215 101.107 19.6991 101.292 19.8338C101.477 19.9685 101.692 20.0562 101.919 20.0895L105.363 20.5935C105.428 20.603 105.489 20.6305 105.54 20.673C105.59 20.7155 105.628 20.7712 105.648 20.8339C105.669 20.8966 105.671 20.9638 105.655 21.0278C105.64 21.0918 105.606 21.1501 105.559 21.1962L103.068 23.6215C102.904 23.7816 102.781 23.9792 102.71 24.1973C102.639 24.4154 102.622 24.6474 102.661 24.8735L103.249 28.3002C103.26 28.3654 103.253 28.4326 103.229 28.494C103.204 28.5554 103.162 28.6086 103.109 28.6475C103.055 28.6864 102.992 28.7095 102.925 28.7141C102.859 28.7187 102.793 28.7046 102.735 28.6735L99.6563 27.0548C99.4534 26.9483 99.2277 26.8927 98.9986 26.8927C98.7695 26.8927 98.5438 26.9483 98.3409 27.0548L95.2629 28.6735C95.2045 28.7044 95.1385 28.7184 95.0726 28.7137C95.0066 28.709 94.9433 28.6859 94.8898 28.647C94.8363 28.6081 94.7948 28.555 94.77 28.4937C94.7452 28.4323 94.7382 28.3653 94.7496 28.3002L95.3369 24.8742C95.3757 24.648 95.3589 24.4158 95.2879 24.1975C95.217 23.9793 95.094 23.7816 94.9296 23.6215L92.4389 21.1968C92.3913 21.1509 92.3576 21.0924 92.3416 21.0282C92.3255 20.964 92.3279 20.8966 92.3483 20.8336C92.3687 20.7707 92.4064 20.7147 92.4571 20.6722C92.5078 20.6296 92.5694 20.6021 92.6349 20.5928L96.0783 20.0895C96.3051 20.0565 96.5205 19.9689 96.706 19.8342C96.8914 19.6995 97.0414 19.5217 97.1429 19.3162L98.6823 16.1968Z'
                    stroke='#E2AB1E'
                    strokeWidth='1.33333'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </g>
        </g>
        <defs>
            <filter
                id='filter0_dd_2386_36090'
                x='0'
                y='2.33317'
                width='163.333'
                height='46'
                filterUnits='userSpaceOnUse'
                colorInterpolationFilters='sRGB'
            >
                <feFlood floodOpacity='0' result='BackgroundImageFix' />
                <feColorMatrix
                    in='SourceAlpha'
                    type='matrix'
                    values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                    result='hardAlpha'
                />
                <feOffset dy='1.33333' />
                <feGaussianBlur stdDeviation='2' />
                <feComposite in2='hardAlpha' operator='out' />
                <feColorMatrix
                    type='matrix'
                    values='0 0 0 0 0.0901961 0 0 0 0 0.0941176 0 0 0 0 0.0980392 0 0 0 0.05 0'
                />
                <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_2386_36090' />
                <feColorMatrix
                    in='SourceAlpha'
                    type='matrix'
                    values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                    result='hardAlpha'
                />
                <feOffset dy='2.66667' />
                <feGaussianBlur stdDeviation='4' />
                <feComposite in2='hardAlpha' operator='out' />
                <feColorMatrix
                    type='matrix'
                    values='0 0 0 0 0.0901961 0 0 0 0 0.0941176 0 0 0 0 0.0980392 0 0 0 0.08 0'
                />
                <feBlend mode='normal' in2='effect1_dropShadow_2386_36090' result='effect2_dropShadow_2386_36090' />
                <feBlend mode='normal' in='SourceGraphic' in2='effect2_dropShadow_2386_36090' result='shape' />
            </filter>
            <filter
                id='filter1_dd_2386_36090'
                x='73.666'
                y='-8.13007e-05'
                width='50.667'
                height='50.6667'
                filterUnits='userSpaceOnUse'
                colorInterpolationFilters='sRGB'
            >
                <feFlood floodOpacity='0' result='BackgroundImageFix' />
                <feColorMatrix
                    in='SourceAlpha'
                    type='matrix'
                    values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                    result='hardAlpha'
                />
                <feOffset dy='1.33333' />
                <feGaussianBlur stdDeviation='2' />
                <feComposite in2='hardAlpha' operator='out' />
                <feColorMatrix
                    type='matrix'
                    values='0 0 0 0 0.0901961 0 0 0 0 0.0941176 0 0 0 0 0.0980392 0 0 0 0.05 0'
                />
                <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_2386_36090' />
                <feColorMatrix
                    in='SourceAlpha'
                    type='matrix'
                    values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                    result='hardAlpha'
                />
                <feOffset dy='2.66667' />
                <feGaussianBlur stdDeviation='4' />
                <feComposite in2='hardAlpha' operator='out' />
                <feColorMatrix
                    type='matrix'
                    values='0 0 0 0 0.0901961 0 0 0 0 0.0941176 0 0 0 0 0.0980392 0 0 0 0.2 0'
                />
                <feBlend mode='normal' in2='effect1_dropShadow_2386_36090' result='effect2_dropShadow_2386_36090' />
                <feBlend mode='normal' in='SourceGraphic' in2='effect2_dropShadow_2386_36090' result='shape' />
            </filter>
            <linearGradient
                id='paint0_linear_2386_36090'
                x1='28.3327'
                y1='17.3333'
                x2='17.666'
                y2='27.9999'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#FF866A' />
                <stop offset='0.32' stopColor='#EC7AB7' />
                <stop offset='0.74' stopColor='#7D77E4' />
                <stop offset='1' stopColor='#60E8D0' />
            </linearGradient>
            <clipPath id='clip0_2386_36090'>
                <rect x='8.33301' y='7.99976' width='146.667' height='29.3333' rx='8' fill='white' />
            </clipPath>
            <clipPath id='clip1_2386_36090'>
                <rect width='10.6667' height='10.6667' fill='white' transform='translate(17.666 17.3333)' />
            </clipPath>
            <clipPath id='clip2_2386_36090'>
                <rect width='10.6667' height='10.6667' fill='white' transform='translate(93.666 17.3333)' />
            </clipPath>
            <clipPath id='clip3_2386_36090'>
                <rect width='10.6667' height='10.6667' fill='white' transform='translate(115 17.3333)' />
            </clipPath>
            <clipPath id='clip4_2386_36090'>
                <rect width='16' height='16' fill='white' transform='translate(90.999 14.6665)' />
            </clipPath>
        </defs>
    </svg>
);

export default FloatingActionBar;